/**
 * Feature gating for the production app.
 *
 * Otto ships with ONE feature: Add Hardware (datasheet + CAD → attributed part).
 * Chat, part studio edits, drawing tools, chat history, billing and the dashboard
 * are still in the codebase but unwired from the UI unless this flag is set:
 *
 *   VITE_ENABLE_LEGACY_FEATURES=true npm run dev
 *
 * It's a build-time flag, so production builds (no env var) never include the
 * legacy routes or navigation.
 */
export const LEGACY_FEATURES_ENABLED = import.meta.env.VITE_ENABLE_LEGACY_FEATURES === 'true';
